<template>
  <div class="login-page">
    <!-- 左侧品牌区 -->
    <aside class="brand-pane">
      <div class="brand-bg" />
      <div class="brand-inner">
        <div class="brand-logo">
          <img src="@/assets/logo-blue.svg" alt="" />
          <span>余干县城投数字服务平台</span>
        </div>
        <div class="brand-content">
          <h1>电子保函<br/>办理平台</h1>
          <p>专业可靠 · 一键申请 · 最快 3min出函 · 真伪可查</p>
          <ul class="brand-points">
            <li><i></i><strong>100% 在线办理</strong><span>申请、审核、出函、下载全流程线上化</span></li>
            <li><i></i><strong>费率最低 0.3%</strong><span>批量议价能力，为企业节省保函支出</span></li>
            <li><i></i><strong>真伪公开查验</strong><span>第三方公开验证，杜绝虚假保函风险</span></li>
            <li><i></i><strong>专属客户经理</strong><span>一对一服务，问题第一时间响应</span></li>
          </ul>
        </div>
        <div class="brand-footer">
          <p>© 2024 余干县干越融资担保有限公司</p>
          <p>咨询热线：蒋经理 19179363419</p>
        </div>
      </div>
    </aside>

    <!-- 右侧表单区 -->
    <main class="form-pane">
      <div class="form-wrap">
        <div class="form-card">
          <header class="form-head">
            <h2>{{ titleMap[mode] }}</h2>
            <p class="hint">{{ hintMap[mode] }}</p>
          </header>

          <div class="auth-tabs" v-if="mode === 'login'">
            <span :class="{ active: type === 'account' }" @click="type = 'account'">账号登录</span>
            <span :class="{ active: type === 'sms' }" @click="type = 'sms'">短信登录</span>
          </div>

          <el-form ref="form" :model="form" :rules="rules" class="auth-form">
            <el-form-item prop="username">
              <div class="field-label">手机号</div>
              <el-input v-model="form.username" placeholder="请输入手机号" autocomplete="off" size="large">
                <i slot="prefix" class="el-icon-mobile-phone"></i>
              </el-input>
            </el-form-item>

            <el-form-item prop="password" v-if="mode === 'login' && type === 'account'">
              <div class="field-label">密码</div>
              <el-input v-model="form.password" placeholder="请输入密码" type="password" autocomplete="off" size="large" show-password>
                <i slot="prefix" class="el-icon-lock"></i>
              </el-input>
            </el-form-item>

            <template v-if="mode !== 'login'">
              <el-form-item prop="password">
                <div class="field-label">设置密码</div>
                <el-input v-model="form.password" placeholder="8-30 位大小写字母+数字" type="password" show-password size="large">
                  <i slot="prefix" class="el-icon-lock"></i>
                </el-input>
              </el-form-item>
              <el-form-item prop="confirmPwd">
                <div class="field-label">确认密码</div>
                <el-input v-model="form.confirmPwd" placeholder="再次输入密码" type="password" show-password size="large">
                  <i slot="prefix" class="el-icon-lock"></i>
                </el-input>
              </el-form-item>
            </template>

            <el-form-item prop="code" v-if="mode !== 'login' || type === 'sms'">
              <div class="field-label">验证码</div>
              <div class="code-row">
                <el-input v-model="form.code" placeholder="请输入验证码" @keyup.enter.native="submit('form')" size="large">
                  <i slot="prefix" class="el-icon-message"></i>
                </el-input>
                <button
                  type="button"
                  :class="['code-btn', !countshow && 'is-disabled']"
                  :disabled="!countshow"
                  @click="getCode"
                >{{ countshow ? '获取验证码' : `${count}s` }}</button>
              </div>
            </el-form-item>

            <div class="form-extras" v-if="mode === 'login'">
              <el-checkbox v-model="remember">
                <span class="muted">记住登录</span>
              </el-checkbox>
              <a class="link" @click="setMode('forget')">忘记密码？</a>
            </div>
          </el-form>

          <button class="g-btn g-btn-primary g-btn-block g-btn-lg submit-btn" @click="submit('form')">
            {{ btnMap[mode] }}
          </button>

          <div class="form-tip">
            <el-checkbox v-model="agreeCheck">
              <span class="muted">已阅读并接受</span>
            </el-checkbox>
            <a class="link" @click="openAgree">《用户协议与隐私政策》</a>
          </div>

          <div class="form-divider">
            <span>合作机构</span>
          </div>

          <div class="form-co">
            <strong>余干县干越融资担保有限公司</strong>
          </div>

          <div class="form-switch" v-if="mode === 'login'">
            还没有账号？<a class="link" @click="setMode('register')">立即注册</a>
          </div>
          <div class="form-switch" v-else>
            已有账号？<a class="link" @click="setMode('login')">返回登录</a>
          </div>

          <div class="form-home">
            <a class="link" @click="$router.push('/')">‹ 返回首页</a>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { login, register, forgetPsd, getPublicKey } from '@/lib/api/login'
import { getNoCode } from '@/lib/api/project'
import { encrypt } from '@/lib/utils/jsencrypt'

export default {
  name: 'LoginPage',
  data () {
    const validatePass = (rule, value, cb) => {
      if (!value) return cb(new Error('请输入密码'))
      if (this.form.confirmPwd) this.$refs.form.validateField('confirmPwd')
      cb()
    }
    const validatePass2 = (rule, value, cb) => {
      if (!value) return cb(new Error('请确认密码'))
      if (value !== this.form.password) return cb(new Error('两次输入密码不一致'))
      cb()
    }
    return {
      mode: 'login',
      type: 'account',
      form: { username: '', password: '', code: '', confirmPwd: '' },
      remember: false,
      agreeCheck: false,
      timer: null,
      count: 60,
      countshow: true,
      rules: {
        username: [
          { required: true, message: '请填写手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确' }
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' },
          { pattern: /(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9A-Za-z]{8,30}/, message: '至少 8 位且包含大小写字母和数字' }
        ],
        confirmPwd: [{ required: true, validator: validatePass2, trigger: 'blur' }],
        code: [{ required: true, message: '请填写验证码', trigger: 'blur' }]
      },
      titleMap: { login: '欢迎回来', register: '创建账号', forget: '找回密码' },
      hintMap: {
        login: '使用手机号 + 密码 或 短信验证码登录',
        register: '完成账号注册，开启电子保函之旅',
        forget: '通过短信验证重置登录密码'
      },
      btnMap: { login: '登 录', register: '注 册', forget: '重置密码' }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (to) {
        const t = to.query.mode
        if (['login', 'register', 'forget'].includes(t)) this.mode = t
      }
    },
    mode () { this.countshow = true; clearInterval(this.timer); this.timer = null }
  },
  beforeDestroy () { clearInterval(this.timer) },
  methods: {
    setMode (m) {
      this.mode = m
      this.form = { username: '', password: '', code: '', confirmPwd: '' }
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    openAgree () {
      const r = this.$router.resolve({ name: 'agree' })
      window.open(r.href, '_blank')
    },
    async getCode () {
      if (!this.countshow) return
      if (!this.form.username) return this.$message.warning('请先填写手机号')
      this.count = 60
      this.countshow = false
      this.timer = setInterval(() => {
        if (this.count > 0) this.count--
        else { this.countshow = true; clearInterval(this.timer); this.timer = null }
      }, 1000)
      try {
        await getNoCode({ phone: this.form.username })
        this.$message.success('验证码已发送')
      } catch (e) { /* ignore */ }
    },
    requireAgree () {
      if (!this.agreeCheck) return this.$message.warning('请阅读并同意《用户协议与隐私政策》'), false
      return true
    },
    submit (formName) {
      if (!this.requireAgree()) return
      this.$refs[formName].validate(async (valid) => {
        if (!valid) return
        if (this.mode === 'login') {
          try {
            const { publicKey } = await getPublicKey()
            const payload = { ...this.form, password: encrypt(this.form.password, publicKey) }
            if (this.type === 'sms') delete payload.password
            const res = await login(payload)
            if (res.code === 200) {
              this.$message.success('登录成功！')
              this.$store.commit('login', res.data.token)
              this.$store.commit('isCheck', res.data.deptId)
              localStorage.setItem('nickName', res.data.user.userName)
              localStorage.setItem('userId', res.data.user.userId)
              const redirect = this.$route.query.redirect || '/'
              this.$router.replace(redirect)
              if (res.data.deptId === 'null') {
                this.$alert('请前往账号认证', '提示', {
                  confirmButtonText: '去认证',
                  callback: () => this.$router.replace('/attestation')
                })
              }
            } else {
              this.$message.error(res.msg)
            }
          } catch (e) {
            this.$message.error('登录失败，请稍后再试')
          }
        } else if (this.mode === 'register') {
          const res = await register({ ...this.form }).catch(() => null)
          if (res && res.code === 200) {
            this.$message.success('注册成功，请登录')
            this.setMode('login')
          } else {
            this.$message.error(res ? res.msg : '注册失败')
          }
        } else if (this.mode === 'forget') {
          try {
            const { publicKey } = await getPublicKey()
            const res = await forgetPsd({ ...this.form, password: encrypt(this.form.password, publicKey) }).catch(() => null)
            if (res && res.code === 200) {
              this.$message.success('密码已重置，请使用新密码登录')
              this.setMode('login')
            } else {
              this.$message.error(res ? res.msg : '重置失败')
            }
          } catch (e) {
            this.$message.error('重置失败，请稍后再试')
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.login-page {
  min-height: 100vh;
  display: flex;
  background: @bg-page;
}

.brand-pane {
  position: relative;
  width: 480px;
  flex-shrink: 0;
  background: linear-gradient(135deg, @primary 0%, #1E40AF 100%);
  color: #fff;
  overflow: hidden;
  display: flex;

  .brand-bg {
    position: absolute;
    inset: 0;
    background-image:
      radial-gradient(circle at 20% 20%, rgba(255, 255, 255, .12), transparent 40%),
      radial-gradient(circle at 80% 80%, rgba(255, 255, 255, .08), transparent 50%);
  }
}

.brand-inner {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 56px 56px 40px;
  z-index: 1;
}

.brand-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 64px;

  img { height: 36px; filter: brightness(0) invert(1); }

  span {
    font-size: 16px;
    font-weight: 600;
    color: rgba(255, 255, 255, .92);
  }
}

.brand-content {
  flex: 1;

  h1 {
    margin: 0 0 16px;
    font-size: 48px;
    font-weight: 800;
    line-height: 1.15;
    letter-spacing: -1px;
  }

  > p {
    margin: 0 0 40px;
    font-size: 15px;
    color: rgba(255, 255, 255, .8);
    line-height: 1.7;
  }
}

.brand-points {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 22px;

  li {
    display: grid;
    grid-template-columns: 28px 1fr;
    column-gap: 14px;
    align-items: start;

    i {
      grid-row: span 2;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: rgba(255, 255, 255, .25);
      margin-top: 4px;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        top: 6px; left: 8px;
        width: 4px; height: 8px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    }

    strong {
      display: block;
      font-size: 15px;
      font-weight: 600;
      color: #fff;
      margin-bottom: 4px;
    }

    span {
      display: block;
      font-size: 13px;
      color: rgba(255, 255, 255, .7);
      line-height: 1.6;
    }
  }
}

.brand-footer {
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, .15);

  p {
    margin: 4px 0;
    font-size: 12px;
    color: rgba(255, 255, 255, .55);
  }
}

.form-pane {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background: #fff;
}

.form-wrap {
  width: 100%;
  max-width: 420px;
}

.form-card {
  background: #fff;

  .form-head {
    margin-bottom: 28px;

    h2 {
      margin: 0 0 6px;
      font-size: 28px;
      color: @text-strong;
      font-weight: 700;
    }
    .hint {
      margin: 0;
      color: @text-muted;
      font-size: 13px;
    }
  }
}

.auth-tabs {
  display: flex;
  gap: 28px;
  margin-bottom: 24px;
  border-bottom: 1px solid @border-light;

  span {
    padding: 10px 0;
    font-size: 14px;
    color: @text-muted;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    transition: color @duration-fast @ease-out;
    &.active {
      color: @primary;
      border-bottom-color: @primary;
      font-weight: 600;
    }
  }
}

.field-label {
  font-size: 12px;
  color: @text-muted;
  margin-bottom: 6px;
}

::v-deep .auth-form .el-form-item {
  margin-bottom: 18px;
}

::v-deep .auth-form .el-input__inner {
  height: 44px;
  font-size: 14px;
}

.code-row {
  display: flex;
  gap: 10px;

  ::v-deep .el-form-item__content {
    display: flex;
    gap: 10px;
  }

  .code-btn {
    height: 44px;
    flex-shrink: 0;
    width: 120px;
    border-radius: 6px;
    border: 1px solid @primary;
    color: @primary;
    background: @primary-soft;
    cursor: pointer;
    font-size: 13px;
    transition: all @duration-fast @ease-out;

    &.is-disabled,
    &:disabled {
      background: @bg-soft;
      color: @text-disabled;
      border-color: @border-base;
      cursor: not-allowed;
    }
  }
}

.form-extras {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.submit-btn {
  height: 48px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 2px;
}

.form-tip {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin-top: 16px;
  font-size: 13px;
}

.muted { color: @text-muted; }
.link { color: @primary; cursor: pointer; }

.form-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 32px 0 16px;

  &::before, &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: @border-light;
  }

  span {
    font-size: 12px;
    color: @text-muted;
  }
}

.form-co {
  text-align: center;
  padding: 12px;
  background: @bg-soft;
  border-radius: @radius-md;
  font-size: 14px;
  color: @primary;
}

.form-switch {
  text-align: center;
  margin-top: 20px;
  font-size: 13px;
  color: @text-muted;
}

.form-home {
  text-align: center;
  margin-top: 12px;
}

@media (max-width: 900px) {
  .login-page { flex-direction: column; }
  .brand-pane {
    width: 100%;
    padding: 32px 24px;
    .brand-inner { padding: 0; }
    .brand-logo { margin-bottom: 24px; }
    .brand-content {
      h1 { font-size: 32px; }
      > p { margin-bottom: 16px; }
      .brand-points { display: none; }
    }
    .brand-footer { margin-top: 16px; padding-top: 12px; }
  }
  .form-pane { padding: 32px 20px; }
}
</style>
